"use strict";
exports.__esModule = true;
exports.DndService = void 0;
var aurelia_event_aggregator_1 = require("aurelia-event-aggregator");
var preview_drawers_1 = require("./preview-drawers");
var doc = document;
var documentElement = doc && doc.documentElement;
var css = "\n/* bcx-aurelia-dnd styles */\n\n/*\nbcx-aurelia-dnd relies on html/body margin 0.\nYour css stack should have done this.\nAdded here as safe guard.\n*/\nhtml, body {\n  margin: 0;\n}\n\n.bcx-dnd-preview {\n  position: absolute !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n  opacity: 0.8;\n  box-shadow: 0 0 16px gray;\n}\n\n.bcx-dnd-preview .bcx-dnd-preview-hide {\n  visibility: hidden !important;\n}\n\n.bcx-dnd-hide {\n  display: none !important;\n}\n\n.bcx-dnd-hide-cursor .bcx-dnd-preview {\n  cursor: none !important;\n}\n\n.bcx-dnd-unselectable {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n";
var _stylesInjected = false;
function injectStyles() {
    if (_stylesInjected)
        return;
    _stylesInjected = true;
    var node = doc.createElement('style');
    node.innerHTML = css;
    node.type = 'text/css';
    if (doc.head.childNodes.length > 0) {
        doc.head.insertBefore(node, doc.head.childNodes[0]);
    }
    else {
        doc.head.appendChild(node);
    }
}
var classes = (function () {
    var cache = {};
    var start = '(?:^|\\s)';
    var end = '(?:\\s|$)';
    function lookupClass(className) {
        var cached = cache[className];
        if (cached) {
            cached.lastIndex = 0;
        }
        else {
            cache[className] = cached = new RegExp(start + className + end, 'g');
        }
        return cached;
    }
    function addClass(el, className) {
        var current = el.className;
        if (!current.length) {
            el.className = className;
        }
        else if (!lookupClass(className).test(current)) {
            el.className += ' ' + className;
        }
    }
    function rmClass(el, className) {
        el.className = el.className.replace(lookupClass(className), ' ').trim();
    }
    return { add: addClass, rm: rmClass };
}());
function whichMouseButton(e) {
    var te = e;
    if (te.touches !== undefined) {
        return te.touches.length;
    }
    if (e.which !== undefined && e.which !== 0) {
        return e.which;
    }
    var me = e;
    if (me.buttons !== undefined) {
        return me.buttons;
    }
    var button = me.button;
    if (button !== undefined) {
        return button & 1 ? 1 : button & 2 ? 3 : (button & 4 ? 2 : 0);
    }
}
function getPageRect(el) {
    var rect = el.getBoundingClientRect();
    return {
        x: rect.left + getScroll('scrollLeft', 'pageXOffset'),
        y: rect.top + getScroll('scrollTop', 'pageYOffset'),
        width: getRectWidth(rect),
        height: getRectHeight(rect)
    };
}
function getScroll(scrollProp, offsetProp) {
    if (typeof window[offsetProp] !== 'undefined') {
        return window[offsetProp];
    }
    if (documentElement.clientHeight) {
        return documentElement[scrollProp];
    }
    return doc.body[scrollProp];
}
function getElementBehindPreview(preview, x, y) {
    var className = '';
    if (preview) {
        className = preview.className;
        preview.className += ' bcx-dnd-hide';
    }
    var el = doc.elementFromPoint(x, y);
    if (preview) {
        preview.className = className;
    }
    return el;
}
function getRectWidth(rect) {
    return rect.width || (rect.right - rect.left);
}
function getRectHeight(rect) {
    return rect.height || (rect.bottom - rect.top);
}
function getParent(el) {
    if (el.parentNode === doc)
        return null;
    return el.parentNode;
}
function isInput(el) {
    return el.tagName === 'INPUT' ||
        el.tagName === 'TEXTAREA' ||
        el.tagName === 'SELECT' ||
        isEditable(el);
}
function isEditable(el) {
    if (!el) {
        return false;
    }
    if (el.contentEditable === 'false') {
        return false;
    }
    if (el.contentEditable === 'true') {
        return true;
    }
    return isEditable(getParent(el));
}
function getEventHost(e) {
    var te = e;
    if (te.targetTouches && te.targetTouches.length) {
        return te.targetTouches[0];
    }
    if (te.changedTouches && te.changedTouches.length) {
        return te.changedTouches[0];
    }
    return e;
}
function getCoord(coord, e) {
    var host = getEventHost(e);
    var missMap = {
        pageX: 'clientX',
        pageY: 'clientY'
    };
    if (coord in missMap && !(coord in host) && missMap[coord] in host) {
        coord = missMap[coord];
    }
    return host[coord];
}
var DndSource = (function () {
    function DndSource(delegate, options) {
        if (options === void 0) { options = {}; }
        if (!delegate) {
            throw new Error("Missing delegate for dnd source.");
        }
        if (typeof delegate.dndModel !== 'function') {
            throw new Error("Missing dndModel() method on dnd source delegate.");
        }
        this.delegate = delegate;
        if (options.element) {
            this.element = options.element;
        }
        else {
            this.element = delegate.dndElement;
        }
        if (options.handler) {
            if (!(options.handler instanceof Element)) {
                throw new Error("specified handler is not a DOM element");
            }
            this.handler = options.handler;
        }
        else {
            this.handler = this.element;
        }
        if (!(this.element instanceof Element)) {
            throw new Error("Missing dndElement or options.element on dnd source delegate.");
        }
        this.noPreview = options.noPreview ? true : false;
        this.hideCursor = options.hideCursor ? true : false;
        this.centerPreviewToMousePosition = options.centerPreviewToMousePosition ? true : false;
    }
    return DndSource;
}());
var DndTarget = (function () {
    function DndTarget(delegate, options) {
        if (options === void 0) { options = {}; }
        if (!delegate) {
            throw new Error("Missing delegate for dnd target.");
        }
        if (typeof delegate.dndCanDrop !== 'function') {
            throw new Error("Missing dndCanDrop() method on delegate.");
        }
        if (typeof delegate.dndDrop !== 'function') {
            throw new Error("Missing dndDrop() method on dnd target delegate.");
        }
        this.delegate = delegate;
        if (options.element) {
            this.element = options.element;
        }
        else {
            this.element = delegate.dndElement;
        }
        if (!(this.element instanceof Element)) {
            throw new Error("Missing dndElement or options.element on dnd target delegate.");
        }
        if (typeof delegate.dndHover === 'function') {
            this.dndHover = delegate.dndHover.bind(delegate);
        }
    }
    return DndTarget;
}());
function indexOfElementOrDelegate(array, delegateOrElement) {
    var test = (delegateOrElement instanceof Element) ?
        (function (o) { return o.element === delegateOrElement; }) :
        (function (o) { return o.delegate === delegateOrElement; });
    var len = array.length;
    for (var i = 0; i < len; i += 1) {
        if (test(array[i]))
            return i;
    }
    return -1;
}
function indexOfHandler(array, handler) {
    var test = (function (o) { return o.handler === handler; });
    var len = array.length;
    for (var i = 0; i < len; i += 1) {
        if (test(array[i]))
            return i;
    }
    return -1;
}
var DndService = (function () {
    function DndService(ea) {
        this.ea = ea;
        this.dndSources = [];
        this.dndTargets = [];
        this.previewDrawers = [];
        injectStyles();
        this.addPreviewDrawer(preview_drawers_1.defaultPreview);
        this.addPreviewDrawer(preview_drawers_1.unknownTagPreview);
        this.addPreviewDrawer(preview_drawers_1.liPreview);
        this.addPreviewDrawer(preview_drawers_1.trPreview);
        this._grab = this._grab.bind(this);
        this._release = this._release.bind(this);
        this._startBecauseMouseMoved = this._startBecauseMouseMoved.bind(this);
        this._preventGrabbed = this._preventGrabbed.bind(this);
        this._drag = this._drag.bind(this);
        this._esc = this._esc.bind(this);
        documentElement.addEventListener('mousedown', this._grab);
        documentElement.addEventListener('touchstart', this._grab, { passive: false });
        documentElement.addEventListener('mouseup', this._release);
        documentElement.addEventListener('touchend', this._release);
    }
    DndService.prototype.addPreviewDrawer = function (drawer) {
        this.previewDrawers.unshift(drawer);
    };
    DndService.prototype.addSource = function (delegate, options) {
        if (options === void 0) { options = {}; }
        this.dndSources.push(new DndSource(delegate, options));
    };
    DndService.prototype.removeSource = function (delegateOrElement) {
        var idx = indexOfElementOrDelegate(this.dndSources, delegateOrElement);
        if (idx >= 0) {
            this.dndSources.splice(idx, 1);
        }
    };
    DndService.prototype.addTarget = function (delegate, options) {
        if (options === void 0) { options = {}; }
        delegate.dnd = {
            isProcessing: false
        };
        var dndTarget = new DndTarget(delegate, options);
        if (this.isProcessing) {
            var canDrop = dndTarget.delegate.dndCanDrop(this.model);
            var dnd = dndTarget.delegate.dnd;
            dnd.canDrop = canDrop;
            dnd.isProcessing = true;
            dnd.model = this.model;
        }
        this.dndTargets.push(dndTarget);
    };
    DndService.prototype.removeTarget = function (delegateOrElement) {
        var idx = indexOfElementOrDelegate(this.dndTargets, delegateOrElement);
        if (idx >= 0) {
            var dndTarget = this.dndTargets[idx];
            dndTarget.delegate.dnd = null;
            this.dndTargets.splice(idx, 1);
        }
    };
    DndService.prototype._sourceOf = function (element) {
        var idx = indexOfHandler(this.dndSources, element);
        return idx >= 0 ? this.dndSources[idx] : undefined;
    };
    DndService.prototype._startListeningEventualMovements = function () {
        documentElement.addEventListener('mousemove', this._startBecauseMouseMoved);
        documentElement.addEventListener('touchmove', this._startBecauseMouseMoved, { passive: false });
        this._element && this._element.addEventListener('touchmove', this._startBecauseMouseMoved, { passive: false });
        this._element && this._element.addEventListener('touchend', this._release, { passive: false });
    };
    DndService.prototype._stopListeningEventualMovements = function () {
        documentElement.removeEventListener('mousemove', this._startBecauseMouseMoved);
        documentElement.removeEventListener('touchmove', this._startBecauseMouseMoved);
        this._element && this._element.removeEventListener('touchmove', this._startBecauseMouseMoved);
    };
    DndService.prototype._startListeningMovements = function () {
        documentElement.addEventListener('selectstart', this._preventGrabbed);
        documentElement.addEventListener('click', this._preventGrabbed);
        documentElement.addEventListener('keydown', this._esc);
        documentElement.addEventListener('mousemove', this._drag);
        documentElement.addEventListener('touchmove', this._drag, { passive: false });
        this._element && this._element.addEventListener('touchmove', this._drag, { passive: false });
    };
    DndService.prototype._stopListeningMovements = function () {
        documentElement.removeEventListener('selectstart', this._preventGrabbed);
        documentElement.removeEventListener('click', this._preventGrabbed);
        documentElement.removeEventListener('keydown', this._esc);
        documentElement.removeEventListener('mousemove', this._drag);
        documentElement.removeEventListener('touchmove', this._drag);
        this._element && this._element.removeEventListener('touchmove', this._drag);
        this._element && this._element.removeEventListener('touchend', this._release);
    };
    DndService.prototype._preventGrabbed = function (e) {
        if (this._grabbed) {
            e.preventDefault();
        }
    };
    DndService.prototype._grab = function (e) {
        this._moveX = getCoord('clientX', e);
        this._moveY = getCoord('clientY', e);
        var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
        if (ignore) {
            return;
        }
        var element = e.target;
        this._element = element;
        var dndSource = this._startingSource(element);
        if (!dndSource)
            return;
        this._grabbed = dndSource;
        this._startListeningEventualMovements();
        if (e.type === 'mousedown') {
            if (isInput(element)) {
                element.focus();
            }
            else {
                e.preventDefault();
            }
        }
        else {
            e.preventDefault();
        }
    };
    DndService.prototype._ungrab = function () {
        this._grabbed = undefined;
        this._stopListeningEventualMovements();
        this._stopListeningMovements();
        this._element = undefined;
    };
    DndService.prototype._release = function (e) {
        this._ungrab();
        if (!this.isProcessing)
            return;
        this.ea && this.ea.publish('dnd:willEnd');
        var shallowTarget = this._landingTargets(e).shallowTarget;
        if (shallowTarget) {
            shallowTarget.delegate.dndDrop(this._locationInfo(shallowTarget.element, e));
        }
        this._cleanup();
        this.ea && this.ea.publish('dnd:didEnd');
    };
    DndService.prototype._startingSource = function (element) {
        if (this.isProcessing) {
            return;
        }
        var dndSource;
        while (element) {
            if (!element)
                break;
            var s = this._sourceOf(element);
            if (s && (typeof s.delegate.dndCanDrag !== 'function' ||
                s.delegate.dndCanDrag())) {
                dndSource = s;
                break;
            }
            element = getParent(element);
        }
        return dndSource;
    };
    DndService.prototype._startBecauseMouseMoved = function (e) {
        if (!this._grabbed)
            return;
        if (whichMouseButton(e) === 0) {
            this._cleanup();
            return;
        }
        var clientX = getCoord('clientX', e);
        var clientY = getCoord('clientY', e);
        if (clientX !== undefined &&
            clientX === this._moveX &&
            clientY !== undefined &&
            clientY === this._moveY) {
            return;
        }
        var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
        if (isInput(elementBehindCursor)) {
            return;
        }
        var grabbed = this._grabbed;
        this._stopListeningEventualMovements();
        this._startListeningMovements();
        if (this.isProcessing)
            this._cleanup();
        this._start(grabbed);
        this._sourceElementRect = getPageRect(this._sourceElement);
        this._offsetX = getCoord('pageX', e) - this._sourceElementRect.x;
        this._offsetY = getCoord('pageY', e) - this._sourceElementRect.y;
        this._renderPreviewImage();
        this._drag(e);
    };
    DndService.prototype._start = function (dndSource) {
        var _this = this;
        this.ea && this.ea.publish('dnd:willStart');
        this.isProcessing = true;
        this.model = dndSource.delegate.dndModel();
        this._sourceElement = dndSource.element;
        if (dndSource.noPreview) {
            this._noPreview = true;
        }
        else if (dndSource.delegate.dndPreview) {
            this._sourcePreview = dndSource.delegate.dndPreview(this.model);
        }
        if (!this._noPreview) {
            if (dndSource.hideCursor) {
                this._hideCursor = true;
            }
            if (dndSource.centerPreviewToMousePosition) {
                this._centerPreviewToMousePosition = true;
            }
        }
        this.dndTargets.forEach(function (dndTarget) {
            var canDrop = dndTarget.delegate.dndCanDrop(_this.model);
            var dnd = dndTarget.delegate.dnd;
            dnd.canDrop = canDrop;
            dnd.isProcessing = true;
            dnd.model = _this.model;
        });
        this.ea && this.ea.publish('dnd:didStart');
    };
    DndService.prototype._cleanup = function () {
        this._ungrab();
        this._removePreviewImage();
        this.isProcessing = undefined;
        this.model = undefined;
        this._sourceElement = undefined;
        this._noPreview = undefined;
        this._hideCursor = undefined;
        this._centerPreviewToMousePosition = undefined;
        this._sourcePreview = undefined;
        this._sourceElementRect = undefined;
        this._offsetX = 0;
        this._offsetY = 0;
        this.dndTargets.forEach(function (dndTarget) {
            var dnd = dndTarget.delegate.dnd;
            dnd.canDrop = undefined;
            dnd.isProcessing = undefined;
            dnd.isHoveringShallowly = undefined;
            dnd.isHovering = undefined;
            dnd.model = undefined;
        });
    };
    DndService.prototype._landingTargets = function (e) {
        var _a;
        if (!this.isProcessing) {
            return { shallowTarget: null, possibleTargets: [] };
        }
        var clientX = getCoord('clientX', e);
        var clientY = getCoord('clientY', e);
        var possibleTargets = this.dndTargets.filter(function (dndTarget) {
            if (!dndTarget.delegate.dnd.canDrop)
                return;
            var clientRect = dndTarget.element.getBoundingClientRect();
            return clientRect.left <= clientX &&
                clientRect.right >= clientX &&
                clientRect.top <= clientY &&
                clientRect.bottom >= clientY;
        });
        var dndTarget;
        var element = getElementBehindPreview(this._preview, clientX, clientY);
        while (!dndTarget && element) {
            var idx = indexOfElementOrDelegate(possibleTargets, element);
            if (idx >= 0) {
                dndTarget = possibleTargets[idx];
            }
            else {
                element = getParent(element);
            }
        }
        if (dndTarget) {
            possibleTargets.splice(possibleTargets.indexOf(dndTarget), 1);
        }
        else if (possibleTargets.length > 0) {
            _a = possibleTargets, dndTarget = _a[0], possibleTargets = _a.slice(1);
        }
        return { shallowTarget: dndTarget, possibleTargets: possibleTargets };
    };
    DndService.prototype._drag = function (e) {
        var _this = this;
        if (!this.isProcessing) {
            return;
        }
        e.preventDefault();
        this._updatePreviewLocation(e);
        var _a = this._landingTargets(e), shallowTarget = _a.shallowTarget, possibleTargets = _a.possibleTargets;
        this.dndTargets.forEach(function (dndTarget) {
            var dnd = dndTarget.delegate.dnd;
            if (!dnd.isProcessing)
                return;
            if (dndTarget === shallowTarget) {
                dnd.isHoveringShallowly = true;
                dnd.isHovering = true;
                if (dndTarget.dndHover) {
                    dndTarget.dndHover(_this._locationInfo(dndTarget.element, e));
                }
            }
            else if (possibleTargets.indexOf(dndTarget) >= 0) {
                dnd.isHoveringShallowly = false;
                dnd.isHovering = true;
                if (dndTarget.dndHover) {
                    dndTarget.dndHover(_this._locationInfo(dndTarget.element, e));
                }
            }
            else {
                dnd.isHoveringShallowly = false;
                dnd.isHovering = false;
            }
        });
    };
    DndService.prototype._esc = function (e) {
        if (!this.isProcessing) {
            return;
        }
        if (e.key === 'Escape') {
            e.preventDefault();
            this._cleanup();
            this.ea && this.ea.publish('dnd:didCancel');
        }
    };
    DndService.prototype._updatePreviewLocation = function (e) {
        if (this._preview) {
            var pageX = getCoord('pageX', e);
            var pageY = getCoord('pageY', e);
            if (this._centerPreviewToMousePosition) {
                var rect = this._preview.getBoundingClientRect();
                var width = getRectWidth(rect);
                var height = getRectHeight(rect);
                this._preview.style.left = (pageX - Math.floor(width / 2)) + 'px';
                this._preview.style.top = (pageY - Math.floor(height / 2)) + 'px';
            }
            else {
                this._preview.style.left = (pageX - this._offsetX) + 'px';
                this._preview.style.top = (pageY - this._offsetY) + 'px';
            }
        }
    };
    DndService.prototype._locationInfo = function (targetElement, e) {
        var mouseStartAt = {
            x: this._sourceElementRect.x + this._offsetX,
            y: this._sourceElementRect.y + this._offsetY
        };
        var pageX = getCoord('pageX', e);
        var pageY = getCoord('pageY', e);
        var mouseEndAt = { x: pageX, y: pageY };
        var targetElementRect = getPageRect(targetElement);
        var previewElementRect;
        if (this._preview) {
            previewElementRect = getPageRect(this._preview);
        }
        else {
            previewElementRect = {
                x: pageX - this._offsetX,
                y: pageY - this._offsetY,
                width: this._sourceElementRect.width,
                height: this._sourceElementRect.height
            };
        }
        return {
            mouseStartAt: mouseStartAt,
            mouseEndAt: mouseEndAt,
            sourceElementRect: this._sourceElementRect,
            targetElementRect: targetElementRect,
            previewElementRect: previewElementRect
        };
    };
    DndService.prototype._renderPreviewImage = function () {
        if (this._preview)
            return;
        if (this._noPreview)
            return;
        var customised = !!this._sourcePreview;
        if (customised) {
            this._preview = this._sourcePreview;
            this._sourcePreview = undefined;
        }
        else {
            var el = this._sourceElement;
            if (!el)
                return;
            for (var i = 0; i < this.previewDrawers.length; i++) {
                this._preview = this.previewDrawers[i](el);
                if (this._preview)
                    break;
            }
            if (!this._preview)
                return;
        }
        classes.add(this._preview, 'bcx-dnd-preview');
        doc.body.appendChild(this._preview);
        classes.add(doc.body, 'bcx-dnd-unselectable');
        if (!customised && getComputedStyle(this._preview).backgroundColor === 'rgba(0, 0, 0, 0)') {
            this._preview.style.backgroundColor = 'white';
        }
        if (this._hideCursor) {
            classes.add(doc.body, 'bcx-dnd-hide-cursor');
        }
    };
    DndService.prototype._removePreviewImage = function () {
        if (this._preview) {
            classes.rm(doc.body, 'bcx-dnd-unselectable');
            classes.rm(doc.body, 'bcx-dnd-hide-cursor');
            getParent(this._preview).removeChild(this._preview);
            this._preview = null;
        }
    };
    return DndService;
}());
exports.DndService = DndService;
DndService['inject'] = [aurelia_event_aggregator_1.EventAggregator];
